import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import $ from "jquery";
//import { strings } from '../Utilities/strings'
import "datatables.net";
import "datatables.net-dt/css/jquery.dataTables.css";
import SideMenu from "./SideMenu";
import Header from "./Header";
import Footer from "./Footer";
import Logout from "./Logout";
import { strings } from "../Utilities/strings";
import Search from "../images/search.png";
//for fontawesome icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";

//for data table
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import searchIcon from "../images/search_icon.svg";
import Pagination from "../Utilities/Pagination";


//for modal
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Modal } from "react-bootstrap";
import {
  addSubAsset,
  getAssets,
  getMainAssets,
  getSubAssets,
} from "../Utilities/URLCONSTANTS";
import { GetApiHeaders } from "../Utilities/NetworkUtilities";
import Loader from "../Utilities/Loader";
import { json } from "react-router-dom";
import * as XLSX from "xlsx";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { customstyles, modalCustomStyles } from "../Utilities/utils";
import Select from "react-select";
import Add_Icon from "../images/Add_Icon.svg";
import Edit_Icon from "../images/edit_icon.svg";
import {
  HiMiniArrowsUpDown,
  HiMiniArrowUp,
  HiMiniArrowDown,
} from "react-icons/hi2";


//Sub Asset Master
const SubAssetMaster = ({ }) => {
  const [loaderImage, setLoaderImage] = useState(
    require("../images/cs_loader.gif")
  );
  const [submitResponse, setsubmitResponse] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showResponsePopup, setShowResponsePopup] = useState(false);
  const [maindropdowndata, setMaindropdowndata] = useState([]);
  const [Assertdropdowndata, setAseertdropdowndata] = useState([]);
  const [name, setName] = useState("");
  const [url, seturl] = useState("");
  const [AssitID, setAssitID] = useState("");
  const [mainAssert, setMainAssert] = useState("");
  const [errorStatus, setErrorStatus] = useState("");
  const [errorDescription, setErrorDescription] = useState("");
  const [errorName, setErrorName] = useState("");
  const [errorMain, setErrorMain] = useState("");
  const [errorAssert, setErrorAssert] = useState("");
  const [errorsubAsset, setErrorsubAsset] = useState("");
  const [errorURL, setErrorURL] = useState("");
  const [id, setId] = useState("");

  const [description, setdescription] = useState("");
  //const [mobileNumber, setMobileNumber] = useState("");
  const [status, setStatus] = useState("");
  const [sno, setSno] = useState(0);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isUpdated, setIsUpdated] = useState(false);
  const [buttonText, setButtonText] = useState("recordSubmitted");
  const [showPopup, setShowPopup] = useState(false);
  const [showWarningPopup, setShowWarningPopup] = useState(false);
  const [showMsg, setShowMsg] = useState("false");
  const [error, setError] = useState("");
  const [modalData, setModalData] = useState({
    id: "",
    name: "",
    url: "",
    AssitID: "",
    description: "",
    // mobileNumber: '',
    status: "",
  });
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]); // For filtered results
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10); // Default: 10 items per page
  const [searchTerm, setSearchTerm] = useState("");
  const [totalItems, setTotalItems] = useState();
  // const totalItems = filteredData.length;
  // In your handleFilter function, update filteredData based on searchTerm
  const handleFilter = (searchTerm) => {
    setSearchTerm(searchTerm);
    if (data != null && data != undefined) {
      const filteredResults = data.filter(
        (item) => {
          return (
            item.mainAssetName.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.assetName.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.subAssetName.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.assetURL.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.status.toLowerCase().includes(searchTerm.toLowerCase())
          )
        });
      setFilteredData(filteredResults);
      handlePageClick(1)
    }
  };

  useEffect(() => {
    if (data != null && data != undefined) {
      //  const totalItems = data.length;
      setFilteredData(data);
      setTotalItems(data.length);
    }
  }, [data]);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const handleItemsPerPageChange = (e) => {
    const selectedValue = parseInt(e.target.value);
    setItemsPerPage(selectedValue);
    setCurrentPage(1); // Reset to the first page when changing items per page.
  };


  const pageNumbers = [];
  for (
    let i = Math.max(2, currentPage - 1);
    i <= Math.min(Math.ceil(totalItems / itemsPerPage) - 1, currentPage + 1);
    i++
  ) {
    // for (let i = 1; i <= Math.ceil(totalItems / itemsPerPage); i++) {
    pageNumbers.push(i);
  }

  const handlePageClick = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= Math.ceil(totalItems / itemsPerPage)) {
      setCurrentPage(pageNumber);
    }
  };
  const exportToExcel = () => {
    const data = [
      [
        "S.no",
        "main Asset Name",
        "asset Name",
        "sub Asset Name",
        "asset URL",
        "description",
        "Status",
      ], // Custom headers
      // ...currentItems.map((item) => [
      ...filteredData.map((item) => [
        item.id,
        item.mainAssetName,
        item.assetName,
        item.subAssetName,
        item.assetURL,
        item.description,
        item.status === "1" ? "Active" : "InActive",
      ]),
    ];

    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");
    // Save the file
    XLSX.writeFile(wb, "SubAssertMaster.xlsx");
  };

  // ...more items
  const handleNameChange = (e) => {
    const input = e.target.value;
    const result = input.replace(/[^a-z_\s]/gi, "")
      .replace(/\b[a-z]/g, (char) => char.toUpperCase());
    setName(result);
    if (result) {
      setErrorsubAsset("");
    }
  };

  const handleAssitIDChange = (e) => {
    const userInput = e.target.value;
    if (!isNaN(userInput)) {
      setAssitID(userInput);
    }
    if (userInput) {
      setErrorAssert("");
    }
  };

  const handledescriptionChange = (e) => {
    const input = e.target.value;
    const result = input
      // .replace(/[^a-z_\s]/gi, "")
      .replace(/\b[a-z]/g, (char) => char.toUpperCase());
    setdescription(result);
    if (result) {
      setErrorDescription("");
    }
  };


  const handleurlChange = (e) => {
    seturl(e.target.value);
    if (e.target.value) {
      setErrorURL("");
    }
  };

  const handleMainAssertChange = (e) => {
    const input = e.target.value;
    if (input) {
      setErrorMain("");
    }
    //const result = input.replace(/[^a-z_\s]/gi, '');
    setMainAssert(input);
  };

  const handleStatus = (e) => {
    setStatus(e.target.value);
    if (e.target.value) {
      setErrorStatus("");
    }
  };
  const fetchMainDropdownData = async () => {
    const apiUrl = getMainAssets;
    const headers = await GetApiHeaders();
    axios
      .get(apiUrl, { headers })
      .then((response) => {
        console.log("response", response);
        setMaindropdowndata(response.data.response.MainAssetMaster);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const fetchAssertDropdownData = async () => {
    const apiUrl = getAssets;
    const headers = await GetApiHeaders();
    axios
      .get(apiUrl, { headers })
      .then((response) => {
        console.log("response", response);
        setAseertdropdowndata(response.data.response.assetMaster);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };
  const handleSubmit = async (item) => {
    // alert(JSON.stringify(item));
    if (AssitID === "") {
      setErrorAssert("Please Select Asset");
    }
    if (description === "") {
      setErrorDescription("Please Enter a Description");
    }
    if (mainAssert === "") {
      setErrorMain("Please Select Main Asset");
    }
    if (name === "") {
      setErrorsubAsset("Please Enter sub Asset");
    }
    if (url === "") {
      setErrorURL("Please Enter a  URL");
    }
    if (description === "") {
      setErrorDescription("Please Enter a Description");
    }
    if (status === "") {
      setErrorStatus("Please Select Status");
    }

    try {
      if (
        (item.name !== "" && item.AssitID !== "",
          item.description !== "" && item.url !== "" && item.mainAssert !== "")
      ) {
        const id = item.id;
        const apiUrl = addSubAsset;
        const headers = await GetApiHeaders();
        const dataToSend = {
          Id: { buttonText } == "Submit" ? "" : id.toString(),
          subAssetName: name,
          assetURL: url,
          assetID: AssitID.toString(),
          description: description,
          mainAssetID: mainAssert.toString(),
          status: status,
        };


        setIsLoading(true);

        const response = await axios.post(apiUrl, dataToSend, { headers });
        setsubmitResponse(response.data.response);
        setShowModal(false);
        setShowResponsePopup(true);
        setIsLoading(false);
        // Handle the response data as needed
        console.log("Response:", response.data);
        // Proceed with data insertion if the API call was successful
        const newId = String(Date.now());
        const newItem = {
          id: newId,
          subAssetName: name,
          assetURL: url,
          assetID: AssitID,
          description: description,
          mainAssetID: mainAssert.toString(),
          status: status,
        };

        setErrorName("");
        setErrorDescription("");
        setErrorStatus("");
        setErrorAssert("");
        setErrorMain("");
        setErrorURL("");
        setIsSubmitted(true);
      } else {
        setIsSubmitted(false);
      }
    } catch (error) {
      console.error("Error:", error);
      setIsSubmitted(false);
      handleUpdate();
    }
  };
  const closeWarning = () => {
    setShowWarningPopup(true);
  };

  const handleUpdate = (item) => {
    if (
      (item.id !== "" && item.name !== "" && item.AssitID !== "",
        item.description !== "" && item.url !== "" && item.mainAssert !== "")
    ) {
      alert(item.mainAssert);
      setErrorName("");
      setErrorDescription("");
      setErrorStatus("");
      setErrorAssert("");
      setErrorMain("");
      setErrorURL("");

      setIsUpdated(true);
    } else {
      // Handle error if required fields are empty
      setIsUpdated(false);
      // setError("Please Enter Mandatory Fields");
    }
  };
  const fetchData = async () => {
    const apiUrl = getSubAssets;
    const headers = await GetApiHeaders();
    setIsLoading(true);
    axios
      .get(apiUrl, { headers })
      .then((response) => {
        console.log("response", response);
        setData(response.data.response.SubAssetMaster);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error fetching data:", error);
      });
  };

  //for data table
  const tableRef = useRef(null);
  useEffect(() => {
    // Check if DataTable is already initialized
    if ($.fn.DataTable.isDataTable(tableRef.current)) {
      // Destroy the existing DataTable instance
      $(tableRef.current).DataTable().destroy();
    }
    // Initialize the DataTable
    $(tableRef.current).DataTable({
      ordering: false, // Disable sorting
    });
    fetchData();
    fetchMainDropdownData();
    fetchAssertDropdownData();
  }, []);
  ///modal popup
  const [showModal, setShowModal] = useState(false);

  const handleresponse = () => {
    setShowResponsePopup(false);
    setShowWarningPopup(false);
    setShowPopup(false);
    setShowModal(false);
    window.location.reload();
  };
  const handleModalOpen = () => {
    setButtonText("Submit");
    setIsSubmitted(false);
    setIsUpdated(false);
    setShowModal(true);
    setId("");
    setName("");
    seturl("");
    setAssitID("");
    setdescription("");
    setMainAssert("");
    setStatus("");
    setModalData({
      id: "",
      subAssetName: "",
      assetURL: "",
      assetID: "",
      description: "",
      mainAssetID: "",
      status: "",
    });
  };

  const handleModalClose = () => {
    setShowPopup(false);
    setShowModal(false);
    setShowWarningPopup(false);
    window.location.reload();
  };
  const handleClose = () => {
    setShowPopup(false);
    setShowModal(false);
    window.location.reload();
  };

  const handleCancel = () => {
    setShowModal(true);
    setShowPopup(false);
    setShowMsg(true);
    // window.location.reload();
  };
  const handleCancel_new = () => {
    setShowModal(true);
    setShowPopup(true);
  };

  const handleCloseWarning = () => {
    setShowModal(false);
    setShowWarningPopup(false);
  };

  const updatedItems = (item, index) => {
    console.log("item id:", item);
    setModalData(item);
    setSno(item.id);
    setId(item.id);
    setName(item.subAssetName);
    seturl(item.assetURL);
    setAssitID(item.assetID);
    setMainAssert(item.mainAssetID);

    setdescription(item.description);
    setStatus(item.status);
    setShowModal(true);
    setButtonText("Update");
    setIsSubmitted(false);
    setIsUpdated(false);
  };

  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const sortedData = [...filteredData].sort((a, b) => {
    if (sortConfig.key) {
      const aValue = a[sortConfig.key]?.toString().toLowerCase();
      const bValue = b[sortConfig.key]?.toString().toLowerCase();
      if (aValue < bValue) return sortConfig.direction === "asc" ? -1 : 1;
      if (aValue > bValue) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    }
    return 0;
  });

  // Handle column sorting
  const handleSort = (key) => {
    setSortConfig((prevConfig) => ({
      key,
      direction: prevConfig.key === key && prevConfig.direction === "asc" ? "desc" : "asc",
    }));
  };

  const renderSortIcon = (key) => {
    if (sortConfig.key !== key) {
      return <HiMiniArrowsUpDown className="ms-1" size={16} />;
    }
    return sortConfig.direction === "asc" ? (
      <HiMiniArrowUp className="ms-1" size={16} />
    ) : (
      <HiMiniArrowDown className="ms-1" size={16} />
    );
  };
  const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);


  const statusOptions = [
    { value: "1", label: "Active" },
    { value: "0", label: "In Active" },
  ];

  return (
    <body id="page-top">
      {/*  <!-- Page Wrapper --> */}
      <div id="wrapper">
        {/*  <!-- Sidebar --> */}
        <SideMenu />
        {/*  <!-- End of Sidebar --> */}
        {/*  <!-- Content Wrapper --> */}
        <div id="content-wrapper" className="d-flex flex-column">
          {/*  <!-- Main Content --> */}
          <div id="content">
            {/*  <!-- Topbar --> */}
            <Header />
            {/* ...Content Start... */}
            <div>
              <div className="container-fluid">
                <div className="card border-0">
                  <div className="card-body pt-0 pl-1">
                    <h5 className="Roles_text">User management</h5>
                    <div className="d-flex justify-content-between">
                      <div>
                        <h6 className="mb-0 Sub_role_text">Sub Asset Master</h6>
                      </div>
                      <span
                        className="d-inline-block"
                        tabIndex="0"
                        data-toggle="tooltip"
                        title="Add Sub Asset"
                      >
                        <Button
                          variant="primary"
                          className="buttons"
                          onClick={handleModalOpen}
                        >
                          <img
                            src={Add_Icon}
                            alt="Add"
                            className="addicon"
                          />
                          Add
                        </Button>
                      </span>
                    </div>
                    <div className="mcrc_hrline"></div>
                    <div
                      className="d-flex justify-content-between align-items-center"
                      style={{ paddingBottom: 20 }}
                    >
                      <div className="d-flex align-items-center">
                        <label className="mr-1">Show</label>
                        <Select
                          options={[
                            { value: 10, label: '10' },
                            { value: 20, label: '20' },
                            { value: 50, label: '50' },
                          ]}
                          value={{
                            value: itemsPerPage,
                            label: String(itemsPerPage),
                          }}
                          onChange={(selected) => {
                            setItemsPerPage(selected.value);
                            setCurrentPage(1);
                          }}
                          isSearchable={false}
                          styles={customstyles}
                        />
                        &nbsp;
                        <label>Entries</label>
                      </div>
                      <div className="d-flex align-items-center">
                        <div className="search-container">
                          <img
                            src={searchIcon}
                            alt="Search"
                            className="search-icon"
                          />

                          <input
                            type="text"
                            placeholder="Type to Search..."
                            value={searchTerm}
                            onChange={(e) => handleFilter(e.target.value)}
                            className="search-input mr-2"
                          />

                          {searchTerm && (
                            <button
                              type="button"
                              className="search-clear-btn"
                              onClick={() => handleFilter("")}
                            >
                              ×
                            </button>
                          )}
                        </div>
                        &nbsp;
                        <button
                          className="btn btn-secondary buttons-excel buttons-html5 mb-0"
                          onClick={exportToExcel}
                        >
                          Download Excel
                        </button>
                      </div>

                    </div>
                    <div>
                      <div className="card data_tableCard">
                        <div className="card-body">
                          <Table className="table table-bordered Content_data_table table-striped">
                            <Thead>
                              <Tr>
                                <Th className="text-center">S.No</Th>
                                <Th
                                  className="text-center cursor-pointer"
                                  onClick={() => handleSort("mainAssetName")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Main Asset Name
                                    {renderSortIcon("mainAssetName")}
                                  </span>
                                </Th>

                                <Th
                                  className="text-center cursor-pointer"
                                  onClick={() => handleSort("assetName")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Asset Name
                                    {renderSortIcon("assetName")}
                                  </span>
                                </Th>

                                <Th
                                  className="text-center cursor-pointer"
                                  onClick={() => handleSort("subAssetName")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Sub Asset Name
                                    {renderSortIcon("subAssetName")}
                                  </span>
                                </Th>

                                <Th
                                  className="text-center cursor-pointer"
                                  onClick={() => handleSort("assetURL")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    URL
                                    {renderSortIcon("assetURL")}
                                  </span>
                                </Th>

                                <Th
                                  className="text-center cursor-pointer"
                                  onClick={() => handleSort("description")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Description
                                    {renderSortIcon("description")}
                                  </span>
                                </Th>
                                <Th
                                  className="text-center cursor-pointer"
                                  onClick={() => handleSort("status")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Status
                                    {renderSortIcon("status")}
                                  </span>
                                </Th>
                                <Th className="text-center">Actions</Th>
                              </Tr>
                            </Thead>

                            <Tbody>
                              {currentItems.length === 0 ? ( // Check if no data is found
                                <Tr>
                                  <Td
                                    colSpan={19}
                                    className="text-center"
                                    style={{ padding: 195, fontSize: 18 }}
                                  >
                                    Data is not available
                                  </Td>
                                </Tr>
                              ) : (
                                currentItems != undefined &&
                                currentItems != null &&
                                currentItems.map((item, index) => (
                                  <Tr>
                                    <Td className="text-left">{(currentPage - 1) * itemsPerPage + index + 1}</Td>

                                    <Td>{item.mainAssetName}</Td>
                                    <Td>{item.assetName}</Td>
                                    <Td>{item.subAssetName}</Td>
                                    <Td>{item.assetURL}</Td>
                                    <Td>{item.description}</Td>
                                    <Td className="text-center">
                                      {item.status === "1" ? (
                                        <span style={{ color: "#4A7729" }}>
                                          Active
                                        </span>
                                      ) : (
                                        <span style={{ color: "#FF0000" }}>
                                          In Active
                                        </span>
                                      )}
                                    </Td>
                                    <Td className="text-center">
                                      <div>
                                        <img
                                          src={Edit_Icon}
                                          alt="Edit Role"
                                          title="Edit Role"
                                          className="editicon"
                                          onClick={() => updatedItems(item)}
                                        />
                                      </div>

                                    </Td>
                                  </Tr>
                                ))
                              )}
                            </Tbody>
                            {isLoading && (
                              <Loader
                                loading={isLoading}
                                message={"Fetching Data. Please Wait..!"}
                                loderimage={loaderImage}
                              />
                            )}
                          </Table>
                          {/* Pagination */}
                          <Pagination
                            currentPage={currentPage}
                            totalItems={sortedData.length}
                            itemsPerPage={itemsPerPage}
                            currentItems={currentItems}
                            onPageChange={handlePageClick}
                          />
                        </div>
                        <div>
                          <Modal
                            show={showModal}
                            onHide={handleModalClose}
                            centered
                            backdrop="static"
                            keyboard={false}
                            size="lg"
                          >
                            <Modal.Header className="border-0 d-flex justify-content-center">
                              <Modal.Title> </Modal.Title>
                              <Button
                                variant="link"
                                className="close btn btn-danger  close_btn"
                                onClick={handleCancel_new}
                              >
                                {" "}
                                X
                              </Button>
                            </Modal.Header>
                            <Modal.Body className="pl-md-5 pr-md-5 pt-0">
                              <div className="d-flex justify-content-center mb-3 font-weight-600">
                                <span className="modal_title">
                                  Sub Asset Master
                                </span>
                              </div>
                              <div className="row">

                                <div className="col-md-6 col-12">
                                  <label
                                    htmlFor="mainAsset"
                                    className="form-label text-md font-weight-600"
                                  >
                                    Main Asset <span style={{ color: "red" }}>*</span>
                                  </label>

                                  <div className="input-group w-100">
                                    <Select
                                      styles={modalCustomStyles}
                                      options={
                                        (Array.isArray(maindropdowndata) ? maindropdowndata : [])
                                          .filter((item) => item.status == 1)
                                          .map((item) => ({
                                            value: String(item.id), // String so existing validation using .length works
                                            label: item.mainAssetName,
                                          }))
                                      }
                                      value={
                                        mainAssert
                                          ? maindropdowndata
                                            .filter((item) => item.status == 1)
                                            .map((item) => ({
                                              value: String(item.id),
                                              label: item.mainAssetName,
                                            }))
                                            .find(
                                              (option) =>
                                                option.value === String(mainAssert)
                                            ) || null
                                          : null
                                      }
                                      onChange={(selectedOption) =>
                                        handleMainAssertChange({
                                          target: {
                                            value: selectedOption?.value || "",
                                          },
                                        })
                                      }
                                      placeholder="Select Main Asset"
                                      isSearchable={false}
                                      isClearable={true}
                                      className="w-100"
                                    />
                                  </div>

                                  <span style={{ color: "red" }}>
                                    {errorMain}
                                  </span>
                                </div>
                                <div className="col-md-6 col-12">
                                  <label
                                    htmlFor="asset"
                                    className="form-label text-md font-weight-600"
                                  >
                                    Asset <span style={{ color: "red" }}>*</span>
                                  </label>

                                  <div className="input-group w-100">
                                    <Select
                                      styles={modalCustomStyles}
                                      options={
                                        (Array.isArray(Assertdropdowndata) ? Assertdropdowndata : [])
                                          .filter((item) => item.status == 1)
                                          .map((item) => ({
                                            value: String(item.id), // Keep as string
                                            label: item.assetName,
                                          }))
                                      }
                                      value={
                                        AssitID
                                          ? Assertdropdowndata
                                            .filter((item) => item.status == 1)
                                            .map((item) => ({
                                              value: String(item.id),
                                              label: item.assetName,
                                            }))
                                            .find(
                                              (option) => option.value === String(AssitID)
                                            ) || null
                                          : null
                                      }
                                      onChange={(selectedOption) =>
                                        handleAssitIDChange({
                                          target: {
                                            value: selectedOption?.value || "",
                                          },
                                        })
                                      }
                                      placeholder="Select Asset"
                                      isSearchable={false}
                                      isClearable={true}
                                      className="w-100"
                                    />
                                  </div>

                                  <span style={{ color: "red" }}>
                                    {errorAssert}
                                  </span>
                                </div>
                                <div className="col-md-6 col-12 mt-2">
                                  <label
                                    for="exampleInputPassword1"
                                    class="form-label text-md  font-weight-600"
                                  >
                                    Sub Asset
                                    <span style={{ color: "red" }}>*</span>
                                  </label>

                                  <div className="input-group input-group w-100">

                                    <input
                                      type="text"
                                      className="form-control p-2"
                                      placeholder="Enter Sub Asset"
                                      value={name}
                                      inputMode="text"
                                      onChange={handleNameChange}
                                    />
                                  </div>
                                  <span style={{ color: "red" }}>
                                    {errorsubAsset}
                                  </span>
                                  <span style={{ color: "red" }}>
                                    {errorName}
                                  </span>
                                </div>
                                <div className="col-md-6 col-12 mt-2">
                                  <div class="mb-3">
                                    <label
                                      for="exampleInputPassword1"
                                      class="form-label text-md  font-weight-600"
                                    >
                                      URL<span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                      class="form-control"
                                      id="textAreaExample1"
                                      rows="2"
                                      value={url}
                                      onChange={handleurlChange}
                                    />
                                    <span style={{ color: "red" }}>
                                      {errorURL}
                                    </span>
                                  </div>
                                </div>
                                <div className="col-md-6 col-12">
                                  <div class="mb-3">
                                    <label
                                      for="exampleInputPassword1"
                                      class="form-label text-md  font-weight-600"
                                    >
                                      Description
                                    </label>
                                    <textarea
                                      class="form-control"
                                      id="textAreaExample1"
                                      rows="2"
                                      value={description}
                                      onChange={handledescriptionChange}
                                      style={{
                                        minHeight: "80px",
                                        resize: "vertical",
                                      }}
                                    ></textarea>
                                    <span style={{ color: "red" }}>
                                      {errorDescription}
                                    </span>
                                  </div>
                                </div>

                                <div className="col-md-6 mx-auto">
                                  <label
                                    for="Input"
                                    class="form-label text-md  font-weight-600"
                                  >
                                    Status
                                  </label>
                                  <div className="input-group input-group w-100">

                                    <Select
                                      styles={modalCustomStyles}
                                      options={statusOptions}
                                      value={statusOptions.find(
                                        (option) => option.value === status
                                      )}
                                      onChange={(selectedOption) =>
                                        handleStatus({
                                          target: { value: selectedOption?.value || "" },
                                        })
                                      }
                                      placeholder="Select Status"
                                      isSearchable={false}
                                      isClearable={true}
                                      className="w-100"
                                    />
                                  </div>
                                  <span style={{ color: "red" }}>
                                    {errorStatus}
                                  </span>
                                </div>
                                {error && (
                                  <span
                                    style={{ color: "red" }}
                                    className="error-message"
                                  >
                                    {error}
                                  </span>
                                )}
                              </div>
                              <div className="row">
                                {isSubmitted ? (
                                  <p style={{ color: "#4A7729" }}>
                                    {strings.recordSubmitted}.
                                  </p>
                                ) : null}
                                {isUpdated ? (
                                  <p style={{ color: "#4A7729" }}>
                                    {strings.updatedSuccessfully}
                                  </p>
                                ) : null}
                              </div>
                              <br />
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <Button
                                  variant="primary"
                                  className="bttn"
                                  onClick={() =>
                                    handleSubmit({
                                      id,
                                      name,
                                      description,
                                      status,
                                      mainAssert,
                                      AssitID,
                                    })
                                  }
                                >
                                  {buttonText}
                                </Button>
                                <div style={{ width: "20px" }}></div>
                                <Button
                                  variant="danger"
                                  className="bttn"
                                  onClick={handleCancel_new}
                                >
                                  Cancel
                                </Button>
                              </div>
                            </Modal.Body>
                          </Modal>
                        </div>
                        <div>
                          <Modal
                            show={showPopup}
                            onHide={handleModalClose}
                            centered
                            backdrop="static"
                            keyboard={false}
                            size="ml"
                          >
                            <Modal.Header className="border-0 d-flex justify-content-center">
                              <Modal.Title>
                                {" "}
                                <span className="modal_title">
                                  Sub Asset Master
                                </span>
                              </Modal.Title>
                              <Button
                                variant="link"
                                className="close btn btn-danger close_btn"
                                onClick={handleCancel}
                              >
                                X
                              </Button>
                            </Modal.Header>

                            <Modal.Body className="pl-md-5 pr-md-5 pt-0">
                              <div className="d-flex justify-content-center mb-3 font-weight-600">
                                {showMsg ? (
                                  <p style={{ color: "#4A7729" }}>
                                    Are You Sure, Do You want close the Window ?
                                  </p>
                                ) : null}
                              </div>
                              <div className="d-flex justify-content-center">
                                <Button
                                  variant="primary"
                                  className="d-flex justify-content-center cancel_button"
                                  onClick={handleClose}
                                >
                                  Yes
                                </Button>
                                &nbsp;&nbsp;
                                <Button
                                  variant="danger"
                                  className="d-flex justify-content-center cancel_button"
                                  onClick={handleCancel}
                                >
                                  No
                                </Button>
                              </div>
                            </Modal.Body>
                          </Modal>
                        </div>
                        <div>
                          <Modal
                            show={showWarningPopup}
                            onHide={handleModalClose}
                            centered
                            backdrop="static"
                            keyboard={false}
                            size="ml"
                          >
                            <Modal.Header className="border-0 d-flex justify-content-center">
                              <Modal.Title>
                                {" "}
                                <span className="modal_title">
                                  Sub Asset Master
                                </span>
                              </Modal.Title>
                              <Button
                                variant="link"
                                className="close btn btn-danger close_btn"
                                onClick={closeWarning}
                              >
                                X
                              </Button>
                            </Modal.Header>

                            <Modal.Body className="pl-md-5 pr-md-5 pt-0">
                              <div className="d-flex justify-content-center mb-3 font-weight-600">
                                {showMsg ? (
                                  <p style={{ color: "#4A7729" }}>
                                    Are You Sure, Do You want close the Window ?
                                  </p>
                                ) : null}
                              </div>
                              <div className="d-flex justify-content-center">
                                <Button
                                  variant="primary"
                                  className="d-flex justify-content-center cancel_button"
                                  onClick={handleClose}
                                >
                                  Yes
                                </Button>
                                &nbsp;&nbsp;
                                <Button
                                  variant="danger"
                                  className="d-flex justify-content-center cancel_button"
                                  onClick={handleCancel}
                                >
                                  No
                                </Button>
                              </div>
                            </Modal.Body>
                          </Modal>
                        </div>
                        <div>
                          <Modal
                            show={showResponsePopup}
                            centered
                            backdrop="static"
                            keyboard={false}
                            size="ml"
                          >
                            <Modal.Header className="border-0 d-flex justify-content-center">
                              <Modal.Title>
                                {" "}
                                <span className="modal_title">
                                  Sub Asset Master
                                </span>
                              </Modal.Title>
                              <Button
                                variant="link"
                                className="close btn btn-danger close_btn"
                                onClick={closeWarning}
                              >
                                X
                              </Button>
                            </Modal.Header>
                            <Modal.Body className="pl-md-5 pr-md-5 pt-0">
                              <div className="d-flex justify-content-center mb-3 font-weight-600">
                                {showMsg ? (
                                  <p style={{ color: "#4A7729" }}>
                                    {submitResponse}
                                  </p>
                                ) : null}
                              </div>
                              <div className="d-flex justify-content-center">
                                <Button
                                  variant="primary"
                                  className="d-flex justify-content-center cancel_button"
                                  onClick={handleresponse}
                                >
                                  Okay
                                </Button>
                                &nbsp;&nbsp;
                              </div>
                            </Modal.Body>
                          </Modal>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* ...End of Main Content...*/}
          {/* ...Footer...*/}
          <Footer />
          {/* ... End of Footer...  */}
        </div>
      </div>
      {/*  <!-- End of Page Wrapper -->
                    <!-- Scroll to Top Button--> */}
      <a className="scroll-to-top rounded" href="#page-top">
        <i className="fas fa-angle-up"></i>
      </a>
      {/*  <!-- Logout Modal--> */}
      <Logout />
    </body>
  );
};
export default SubAssetMaster;
